import { createFileRoute } from '@tanstack/react-router'
import LeaveTracking from '@/features/leave-tracking'

export const Route = createFileRoute('/_authenticated/leave-tracking/')({
  component: LeaveTracking,
}) 